import { render, staticRenderFns } from "./CollectManage.vue?vue&type=template&id=b717d0c0&scoped=true&"
import script from "./CollectManage.vue?vue&type=script&lang=js&"
export * from "./CollectManage.vue?vue&type=script&lang=js&"
import style1 from "./CollectManage.vue?vue&type=style&index=1&lang=css&"
import style2 from "./CollectManage.vue?vue&type=style&index=2&id=b717d0c0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b717d0c0",
  null
  
)

export default component.exports